import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createCartUpdatedIntent(): WebViewIntent {
  return createIntent('CART_UPDATED')
}

export function createClickAndCollectUnavailableDrawerOpenIntent(cartId: string): WebViewIntent {
  return createIntent('CLICK_AND_COLLECT_UNAVAILABLE_DRAWER_OPEN', { cartId })
}

export function createClickAndCollectCartUpdatedIntent(): WebViewIntent {
  return createIntent('CLICK_AND_COLLECT_CART_UPDATED')
}
